"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const QuestelServicesClient_1 = require("../QuestelServicesClient");
const vuex_module_decorators_1 = require("vuex-module-decorators");
const CommonModule_1 = __importDefault(require("../store/CommonModule"));
class LoginService {
    constructor(vuexStore) {
        this.client = new QuestelServicesClient_1.QuestelServicesClient(vuexStore, '');
        this.commonState = vuex_module_decorators_1.getModule(CommonModule_1.default, vuexStore);
    }
    authenticate(loginDto) {
        return this.client.postJson(`${this.commonState.authenticationUrl}/api/serviceuser/Authenticate`, loginDto);
    }
    authenticateUmv2(umv2Data) {
        return this.client.postJson(`${this.commonState.authenticationUrl}/api/serviceuser/Authenticate-umv2`, umv2Data);
    }
    resetPassword(resetPasswordDto) {
        return this.client.postJson(`${this.commonState.authenticationUrl}/api/serviceuser/PasswordRecovery`, resetPasswordDto);
    }
    updatePassword(passwordToken, newPassword) {
        if (!passwordToken || !passwordToken.trim()) {
            throw "Password token cannot be null or white space";
        }
        if (!newPassword || !newPassword.trim()) {
            throw "New password cannot be null or white space";
        }
        return this.client.postJson(`${this.commonState.authenticationUrl}/api/serviceuser/ForgotPassword?token=${passwordToken}`, newPassword);
    }
    validateToken(resetToken) {
        return this.client.postJson(`${this.commonState.authenticationUrl}/api/serviceuser/ValidateToken?token=${resetToken}`, null);
    }
}
exports.LoginService = LoginService;
//# sourceMappingURL=LoginService.js.map